import React, { useEffect, useMemo, useState } from "react";
import { TransportMode, TransportSearch } from "../../types";
import { formatDate } from "../../functions/Utils";

type Props = {
  search: TransportSearch;
  direction: "outbound" | "inbound";
  transportType: TransportMode;
};

const TransportSearchHeader: React.FC<Props> = ({
  search,
  direction,
  transportType,
}) => {
  return (
    <div className="d-flex justify-content-center py-3">
      <div className="btn-group rounded-4 border border-gray-300" role="group">
        <button
          type="button"
          className={`text-center btn btn-outline-secondary border-0 rounded-4 px-5 ${
            direction === "outbound" ? "active" : ""
          }`}
        >
          <div className="title fw-bold h5 d-block m-0">
            {search.origin.cityname} → {search.destination.cityname}
          </div>
          <div className="d-block">
            {search.departure_date ? formatDate(search.departure_date) : ""}
          </div>
        </button>
        {search.return_date && (
          <button
            type="button"
            className={`text-center btn btn-outline-secondary border-0 rounded-4 px-5 ${
              direction === "inbound" ? "active" : ""
            }`}
          >
            <div className="title fw-bold h5 d-block m-0">
              {search.destination.cityname} → {search.origin.cityname}
            </div>
            <div className="d-block">
              {search.return_date ? formatDate(search.return_date) : ""}
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default TransportSearchHeader;
